import {
  BulbIcon,
  CheckIcon,
  LinkIcon,
  PlusIcon,
  RestartIcon,
  RulesIcon,
  SlidersIcon,
} from './icons';

export interface MenuAction {
  key: string;
  label: string;
  icon: React.ReactNode;
  onSelect: () => void;
  disabled?: boolean;
  note?: string;
  divider?: boolean;
}

export const menuIcons = {
  nudge: <BulbIcon />,
  check: <CheckIcon />,
  restart: <RestartIcon />,
  rules: <RulesIcon />,
  collection: <PlusIcon />,
  settings: <SlidersIcon />,
  export: <LinkIcon />,
};

export function Menu({ actions, onClose }: { actions: MenuAction[]; onClose: () => void }) {
  return (
    <>
      <div
        className="fixed inset-0 z-30 bg-[rgba(31,30,28,0.28)]"
        onClick={onClose}
        aria-hidden="true"
      />
      <div
        role="menu"
        aria-label="Puzzle menu"
        className="absolute top-[50px] right-2 z-40 flex w-[min(240px,calc(100vw-24px))] flex-col rounded-[16px] border border-line bg-surface p-2 shadow-[0_8px_24px_rgba(31,30,28,0.16)]"
      >
        {actions.map((a) => (
          <div key={a.key}>
            {a.divider && <div className="mx-3 my-1 h-px bg-line-soft" />}
            <button
              type="button"
              role="menuitem"
              disabled={a.disabled}
              onClick={() => {
                onClose();
                a.onSelect();
              }}
              className="flex min-h-12 w-full items-center gap-3 rounded-btn border-0 bg-transparent px-3 text-left text-[15px] font-medium text-ink hover:bg-bg disabled:opacity-45"
            >
              {a.icon}
              <span className="flex flex-col">
                {a.label}
                {a.note && <span className="text-[12px] font-normal text-muted">{a.note}</span>}
              </span>
            </button>
          </div>
        ))}
      </div>
    </>
  );
}
